"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _order = require("@/api/order");
var _encrypted = require("@/api/encrypted");
var _encrypt = require("@/utils/encrypt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: ['orderId', 'merchantId'],
  components: {},
  data: function data() {
    return {
      drewTip: '查看浓度匹配算法详情（百分比第一行代表有数据，第二行代表无数据时的统计）',
      titleTip: '浓度风控详情',
      loading: true,
      dialogVisible: false,
      tableData: [],
      selectedItem: {},
      headerCellStyle: {
        'text-align': 'center'
      },
      //只能是这个名字
      multiDataList: [],
      showDetail: false
    };
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.loading = true;
        this.getOrderRiskControl();
      }
    }
  },
  methods: {
    getOrderRiskControl: function getOrderRiskControl() {
      var _this = this;
      console.log('用户信息', this.orderId, '商户信息', this.merchantId);
      this.useMultiTable();
      return;
      (0, _order.getOrderRiskControl)(this.orderId).then(function (res) {
        console.log('resss', res);
        _this.tableData = res || [];
        console.log('表格信息', _this.tableData);
        _this.loading = false;
      });
    },
    useMultiTable: function () {
      var _useMultiTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var pid, params, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                pid = (0, _encrypt.encrypt)(this.orderId.seller_id.toString());
                params = {
                  platform_id: pid
                };
                _context.next = 5;
                return (0, _encrypted.useMultiTableAPI)(params);
              case 5:
                res = _context.sent;
                console.log('获取其他统计数据成功: ', res);
                if (res.length) {
                  this.multiDataList = res;
                  console.log('this.multiDataList', this.multiDataList);
                  this.showDetail = true;
                  this.loading = false;
                }
                _context.next = 13;
                break;
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.log('error', _context.t0);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));
      function useMultiTable() {
        return _useMultiTable.apply(this, arguments);
      }
      return useMultiTable;
    }(),
    getType: function getType(row) {
      if (row.curentPhase == 'risk_T0') {
        return '初始数据';
      }
      if (row.curentPhase == 'risk_T1') {
        return '隔天数据';
      }
      if (row.curentPhase == 'risk_T3') {
        return '三天数据';
      }
      if (row.curentPhase == 'risk_T7') {
        return '七天评估';
      }
      // return "未知";
    },
    getLevel: function getLevel(row) {
      console.log(row);
      if (row.curentPhase == 'risk_T0') {
        switch (row.riskLevel) {
          case '0':
            return '无结果';
          case '998':
            return '极高危';
          case '996':
            return '高危';
          case '979':
            return '中风险';
          case '975':
            return '正常';
          case '969':
            return '低风险';
          case '989':
            return '优质';
        }
      }
      if (row.curentPhase == 'risk_T1') {
        switch (row.riskLevel) {
          case '0':
            return row.riskContent;
          case '998':
            return '极高危';
          case '996':
            return '高危';
          case '979':
            return '中风险';
          case '975':
            return '正常';
          case '969':
            return '低风险';
          case '989':
            return '优质';
        }
      }
      if (row.curentPhase == 'risk_T3') {
        switch (row.riskLevel) {
          case '0':
            return row.riskContent;
          case '998':
            return '极高风险';
          case '996':
            return '高风险';
          case '979':
            return '中高风险';
          case '975':
            return '低风险';
          case '969':
            return '无异常人群';
        }
      }
      if (row.curentPhase == 'risk_T7') {
        switch (row.riskLevel) {
          case '998':
            return '极高聚集';
          case '996':
            return '高聚集';
          case '979':
            return '中聚集';
          case '975':
            return '低聚集';
          case '969':
            return '无异常聚集';
          default:
            return row.riskContent;
        }
      }
      // return "未知";
    },
    getRecom: function getRecom(row) {
      if (row.key == 'rentOnlineRiskLevelOverall') {
        switch (row.value) {
          case '0':
            return '建议发货';
          case '1':
            return '可适当放宽商家风控条件，提高发货率';
          case '2':
            return '缴纳押金或者预缴多期租金情况下，谨慎发货';
          case '3':
            return '不建议发货';
        }
      }
      if (row.key == 'rentOnlineRiskLevelMultiRent') {
        switch (row.value) {
          case '0':
            return '无明显共租行为';
          case '1':
            return '共租行为较多';
          case '2':
            return '共租行为过多，明显超过平均水位';
        }
      }
      if (row.key == 'rentOnlineRiskLevelFulfill') {
        return '该字段仅供商家参考使用，等级为1不一定代表用户有较高风险';
      }

      // return "未知"
    },
    getTask: function getTask(row) {
      if (row.curentPhase == 'risk_T0') {
        return '实时模型输出，用于判断是否通过订单。用户在完成押金授权，或者租金免密代扣授权或者人脸之后即可查询，最多可查询24小时之内的订单，注意，同步风险识别是根据用户实时行为计算的模型，需要在用户授权后尽快查询';
      }
      if (row.curentPhase == 'risk_T1') {
        return '用户下单后到发货前的异变判断';
      }
      if (row.curentPhase == 'risk_T3') {
        return '下单到收货间的异变判断';
      }
      if (row.curentPhase == 'risk_T7') {
        return '近7天内目前未被取消的订单即可查询，输出结果为是否与中介关联以及关联的程度';
      }
      // return "未知";
    }
  }
};
exports.default = _default;